module.exports = __webpack_public_path__ + "static/media/review-15.78cebc14.jpg";